import { combineEpics } from 'redux-observable'
import { adminOrganisationEpic } from './adminOrganisationEpic'
import { auditSubscriptionEpic } from './auditSubscriptionEpic'
import { collectionPrepareEpic } from './collectionPrepareEpic'
import { ConnectionDependencies, connectionEpic } from './connectionEpic'
import { dealEventEpic } from './dealEventEpic'
import { DiagnosticsActions, DiagnosticsDependencies, diagnosticsEpic } from './diagnosticsEpic'
import { entitySubscriptionEpic } from './entitySubscriptionEpic'
import { eventResponseEpic } from './eventResponseEpic'
import { gridEpic } from './gridEpic'
import { gridSettingsEpic } from './gridSettingsEpic'
import { growlTimeoutEpic } from './growlTimeoutEpic'
import { heartbeatEpic } from './heartbeatEpic'
import { negotiationModifyEpic } from './negotiationModifyEpic'
import { orderModifyEpic } from './orderModifyEpic'
import { orderPrepareEpic, orderUnprepareEpic } from './orderPrepareEpics'
import { platformVersionEpic } from './platformVersionEpic'
import { rfqEventEpic } from './rfqEventEpic'
import { snapshotEpic } from './snapshotEpic'
import { snapshotIntegrityEpic } from './snapshotIntegrityEpic'
import { NotificationsToastActions, ToastDependencies, toastEpic } from './toastEpic'
import { WindowActions, WindowDependencies, windowEpic } from './windowEpic'
import { workflowEpic } from './workflowEpic'
import { ActivityMonitorActions } from 'store/activityMonitor/activityMonitorActions'
import { ConnectionActions } from 'store/connection'
import { GridActions } from 'store/grid'
import { NotificationActions } from 'store/notification'
import { RepositoryActions } from 'store/repository'
import { SelectionActions } from 'store/selection'
import { TimeActions } from 'store/time'
import { EntityReducerActions } from 'store/repository/entityReducer'
import {
  ClientLoginAction,
  ClientLogToServerAction,
  ClientSubscribeBatchAction,
  CrudActions,
  DealActions,
  HeartbeatAction,
  LogToServerActions,
  ServerAction,
  WorkflowActions
} from 'api'
import { AuditActions } from 'api/AuditActions'
import { SpreadsheetUploadActions } from 'store/spreadsheetUpload/spreadsheetUploadActions'
import { mteUploadDealLoadingEpic } from 'store/spreadsheetUpload/spreadsheetUploadEpic'
import { logStreamEpic } from './logStreamEpic'
import { negotiationOverrideEpic } from './negotiationOverrideEpic'
import { axeModifyEpic } from './axeModifyEpic'
import { axeEventReceivedEpic } from './axeEventEpic'

export const globalEpic = combineEpics(
  adminOrganisationEpic,
  auditSubscriptionEpic,
  axeModifyEpic,
  axeEventReceivedEpic,
  collectionPrepareEpic,
  connectionEpic,
  dealEventEpic,
  diagnosticsEpic,
  entitySubscriptionEpic,
  eventResponseEpic,
  gridEpic,
  gridSettingsEpic,
  growlTimeoutEpic,
  heartbeatEpic,
  logStreamEpic,
  negotiationModifyEpic,
  negotiationOverrideEpic,
  orderModifyEpic,
  orderPrepareEpic,
  orderUnprepareEpic,
  platformVersionEpic,
  rfqEventEpic,
  toastEpic,
  snapshotEpic,
  snapshotIntegrityEpic,
  // mteUploadDealSubscribeEpic,
  mteUploadDealLoadingEpic,
  windowEpic,
  workflowEpic
)

export type Dependencies = ConnectionDependencies | ToastDependencies | WindowDependencies | DiagnosticsDependencies
export type BTQAction =
  | DiagnosticsActions
  | NotificationsToastActions
  | WindowActions
  | ActivityMonitorActions
  | EntityReducerActions
  | NotificationActions
  | ConnectionActions
  | GridActions
  | RepositoryActions
  | SelectionActions
  | TimeActions
  | WorkflowActions
  | AuditActions
  | CrudActions
  | ClientLoginAction
  | ClientLogToServerAction
  | ClientSubscribeBatchAction
  | ServerAction
  | LogToServerActions
  | HeartbeatAction
  | SpreadsheetUploadActions
  | DealActions
